import ICON from "components/icons/multipleImagesIcon.svg";

import "./buttons.scss";

export const GalleryButton = (props: {
  onClick?: () => void;
}): JSX.Element => {
  const onClick = () => {
    props.onClick && props.onClick();
  };

  return (
    <button
      className="rg-button gallery icon"
      onClick={onClick}
    >
      <img src={ICON} alt="" />
    </button>
  );
};
